import React, { useEffect, useState } from 'react';
import MyTopbar from '../component/MyTopbar'
import { BiCalendarEdit, BiSolidTrash, BiLinkExternal, BiCopy } from "react-icons/bi";
import { BsCalendar3, BsFillPersonPlusFill, BsFillPeopleFill } from "react-icons/bs";
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useSearchParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingScreen from '../component/LoadingScreen';
import Moment from 'react-moment';
import ReactPaginate from 'react-paginate';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import moment from 'moment';
import { Buffer } from 'buffer';
import { InteractionStatus, InteractionType, InteractionRequiredAuthError, AccountInfo } from "@azure/msal-browser";
import { acquireGetAccessToken } from "../utils/GetGrapApi"
import {
    useMsal,
    MsalAuthenticationTemplate,
    useIsAuthenticated,
} from "@azure/msal-react";
import { callMsGraph } from '../callMsGroup';
import { off } from 'process';

// CSS animations for expired badge
const expiredAnimations = `
@keyframes expiredPulse {
  0% { transform: scale(1); opacity: 0.9; }
  50% { transform: scale(1.08); opacity: 1; }
  100% { transform: scale(1); opacity: 0.9; }
}

@keyframes expiredGlow {
  0% { box-shadow: 0 10px 25px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.2), 0 0 15px rgba(255,0,0,0.2); }
  100% { box-shadow: 0 10px 25px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.2), 0 0 20px rgba(255,0,0,0.3); }
}

@keyframes shine {
  0% { left: -100%; }
  100% { left: 100%; }
}
`;

// Inject animations into document head
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = expiredAnimations;
  if (!document.head.querySelector('style[data-expired-animations]')) {
    styleElement.setAttribute('data-expired-animations', 'true');
    document.head.appendChild(styleElement);
  }
}

function ConfirmModal(props: any) {

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    ยืนยัน
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    คุณแน่ใจหรือไม่ที่ต้องการลบข้อมูลนี้ ?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
                <Button onClick={props.onDelete}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
}
function MyEvent() {
    const { inProgress, instance, accounts } = useMsal();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [item, setItem] = useState("")
    const tokensesSionStorage = sessionStorage.getItem("accessToken");
    const [hiddenExpiredEvents, setHiddenExpiredEvents] = useState<string[]>([]);
    const [eventsLists, setEventsLists] = useState({
        eventsLists: [],
        limit: 0,
        offset: 12,
        total: 0,
        totalPages: 10
    });
    const [eventNumber, setEventNumber] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const [keyword, setKeyword] = useState("");
    const [search, setSearch] = useState(false)
    const [isAdmin, setIsAdmin] = useState(false)
    const [offset, setOffset] = useState(0)
    const [limit, setLimit] = useState(12)
    const [token, setToken] = useState("");
    const [tokenProfile, setTokenProfile] = useState("");
    const [profile, setProfile] = useState({ jobTitle: "" });
    const [photoData, setPhotoData] = useState("");
    const [defualtEvents, setDefualtEvents] = useState([])
    const [expiredFilter, setExpiredFilter] = useState<string>("active"); // "active" | "expired" | "all"
    const auths = {
        headers: {
            "Content-type": "application/json",
            'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken") || token
        }
    }
    const auth = {
        headers: {
            "Content-type": "application/json",
            'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken") || token
        },
        params: { keyword: keyword, limit: limit, offset: offset }
    };

    //console.log('accessToken=:', localStorage.getItem("accessToken") || token);
    
    const hendleConfirmModal = (evNumber: string) => {
        setEventNumber(evNumber);
        setModalShow(true);
    }

    const renderTooltip = (props:any) => {
        const emails = props.split(','); // แยกอีเมลตามเครื่องหมายคอมมา
      
        return (
            <Tooltip id="button-tooltip" {...props}>
              {emails.map((email:any, index:any) => (
                <div key={index}>{email}</div> // แสดงอีเมลแต่ละอันในบรรทัดใหม่
              ))}
            </Tooltip>
          );
      };

      const convertToG7 = (date:any) => {
        //date = '2024-08-27T08:44:44.797Z';
        return moment(date)
            .format('DD-MMM-YYYY');
    };

    const isEventExpired = (startDate: any, endDate: any) => {
        if (!startDate || !endDate) return false;
        const today = moment().startOf('day');
        const eventStartDate = moment(startDate).startOf('day');
        const eventEndDate = moment(endDate).startOf('day');
        
        // Event is expired only if it has started AND ended
        return eventStartDate.isSameOrBefore(today) && eventEndDate.isBefore(today);
    };

    const hideExpiredOverlay = (eventNumber: string) => {
        setHiddenExpiredEvents(prev => [...prev, eventNumber]);
    };

    const isExpiredOverlayHidden = (eventNumber: string) => {
        return hiddenExpiredEvents.includes(eventNumber);
    };

    useEffect( () => {
        if (!token && inProgress === InteractionStatus.None) {
         acquireGetAccessToken(instance, accounts).then(async (res: any) => {
                setToken(res.accessToken)
                setTokenProfile(res.accessTokenProfile)
                const response1 = await axios("https://graph.microsoft.com/v1.0/me/photo/$value", {
                    headers: { Authorization: `Bearer ${res.accessTokenProfile}` },
                    responseType: "arraybuffer"
                });
                const avatar = Buffer.from(response1.data, "binary").toString("base64");
                setPhotoData("data:image/jpeg;base64, " + avatar);
                sessionStorage.setItem("PhotoData", "data:image/jpeg;base64, " + avatar);


                const response2 = await axios("https://graph.microsoft.com/v1.0/me", {
                    headers: { Authorization: `Bearer ${res.accessTokenProfile}` }
                });
                setProfile(response2.data);
                 sessionStorage.setItem("Profile", response2.data);
            }) 
        }
      }, [inProgress]);
    
      useEffect(() => {
        loadData();
        const CheckRole = async () => {
              if (tokenProfile) {
                  try {
                      const groupsData = await callMsGraph(tokenProfile, "/me/transitiveMemberOf/microsoft.graph.group?$top=999");
                      const groupExists = await groupsData.value.some((group:any) => group.id === process.env.REACT_APP_SEC_ADMIN);
                      console.log("groupExists=>", groupExists);
                      setIsAdmin(groupExists)
                  } catch(error) {
                      console.error('error=',error);
                  }
             }
          }
  
      CheckRole();

      },[token,offset]);

      //console.log('isAdmin=',isAdmin);
      
    const loadData = async() => {
        setLoading(true);
        axios.get(process.env.REACT_APP_API_END_POINT + '/v1/Events/MyEvents', auth)
            .then(function (response) {
                setItem(response.data)
                // Sort events by creation date (latest first) as fallback
                const sortedData = {
                    ...response.data,
                    eventsLists: response.data.eventsLists.sort((a: any, b: any) => {
                        return new Date(b.createdAt || b.startDate).getTime() - new Date(a.createdAt || a.startDate).getTime();
                    })
                };
                setEventsLists(sortedData);
                if (sortedData.eventsLists.length < 12) {
                    let block = 12 - sortedData.eventsLists.length;
                    let evArr: any = [];
                    for (var i = 0; i < block; i++) {
                        evArr.push(i);
                    }
                    setDefualtEvents(evArr);

                }
                //console.log(response);
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            })
            .finally(function () {
                setLoading(false);
            });
    }
    const hendleDelete = () => {
        setModalShow(false)
        axios.delete(process.env.REACT_APP_API_END_POINT + '/v1/Events/delete?eventNumber=' + eventNumber,auths)
            .then(function (response) {
                loadData()
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            })
            .finally(function () {
                setLoading(false);
            });
    }
    const firstOwner = (owers: string) => {
        if (owers !== "") {
            let arrOwner = owers.split(";");
            return arrOwner[0];
        } else {
            return "Owner not found";
        }
    }
    const copyUrl = async (url: string, evNumber: string) => {
        try {
            toast.success('Coppied ' + evNumber, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light"
            });
            //console.log("xxx")
            await navigator.clipboard.writeText(url);

        } catch (err) {
            //console.error('Failed to copy: ', err);
        }
    }
    const heandleSearch = (key: string) => {

        setKeyword(key)
        setSearch(true)
    }
    const handlePageClick = (event: any) => {
        const selectedPage = event.selected;
        const newOffset = selectedPage * limit;
        setOffset(newOffset);
        setDefualtEvents([]);
    };

    useEffect(() => {
        if (search) {
            loadData()
        }
    }, [keyword]);

    // useEffect(() => {
    //         loadData()
    // }, [offset]);
    // useEffect(() => {
    //     if(!token){
    //         acquireAccessToken();
    //         console.log('acquireAccessToken=','acquireAccessToken');
    //     }
    // },[]);
    
    if (loading) {
        return <LoadingScreen />
    }
    return (
        <>
            <MyTopbar triggerSearch={heandleSearch} token={token}  photoData={photoData} isAdmin={isAdmin}/>
            {
                (keyword !== "") ?
                    <div className='container-fluid searh-nav text-start border-bottom pt-2'>
                        <div className='row'>
                            <div className='col-12 text-start'>Search Keyword : {keyword} <Button variant="link" className='clearSearch' onClick={() => setKeyword("")}>Clear</Button></div>
                            {/* <div className='col-6 text-end'>Total {eventsLists.total} Events</div> */}
                        </div>

                    </div>
                    : <></>
            }

            <div className='container-fluid mt-4'>

                {/* Filter Section */}
                <div className='row mb-3'>
                    <div className='col-12'>
                        <div className='d-flex align-items-center justify-content-end gap-2'>
                            {/* <label className='mb-0 fw-bold'>Filter Events:</label> */}
                            <div className='btn-group' role='group'>
                                <button
                                    type='button'
                                    className={`btn ${expiredFilter === 'active' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => setExpiredFilter('active')}
                                >
                                    ยังไม่หมดอายุ
                                </button>
                                <button
                                    type='button'
                                    className={`btn ${expiredFilter === 'expired' ? 'btn-danger' : 'btn-outline-danger'}`}
                                    onClick={() => setExpiredFilter('expired')}
                                >
                                    หมดอายุแล้ว
                                </button>
                                <button
                                    type='button'
                                    className={`btn ${expiredFilter === 'all' ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                    onClick={() => setExpiredFilter('all')}
                                >
                                    ทั้งหมด
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row event-grid'>
                    {

                        (eventsLists.eventsLists.length > 0) ?
                            (() => {
                                const filteredEvents = eventsLists.eventsLists.filter((item: any) => {
                                    if (expiredFilter === 'all') return true;
                                    const expired = isEventExpired(item.startDate, item.endDate);
                                    if (expiredFilter === 'active') return !expired;
                                    if (expiredFilter === 'expired') return expired;
                                    return true;
                                });
                                
                                return filteredEvents.map(
                                (item: any,
                                    index: number) => (
                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 p-3' key={`A${index}`}>
                                        <div className={`event-item-card ${isEventExpired(item.startDate, item.endDate) ? 'expired-event' : ''}`} style={{ position: 'relative' }}>
                                            {isEventExpired(item.startDate, item.endDate) && !isExpiredOverlayHidden(item.eventNumber) && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    zIndex: 10,
                                                    borderRadius: '8px'
                                                }}>
                                                    {/* Close button */}
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            hideExpiredOverlay(item.eventNumber);
                                                        }}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '10px',
                                                            right: '10px',
                                                            background: 'rgba(255, 255, 255, 0.9)',
                                                            border: 'none',
                                                            borderRadius: '50%',
                                                            width: '30px',
                                                            height: '30px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: '#666',
                                                            zIndex: 11,
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
                                                            e.currentTarget.style.color = '#000';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
                                                            e.currentTarget.style.color = '#666';
                                                        }}
                                                        title="Hide expired overlay"
                                                    >
                                                        ×
                                                    </button>
                                                    
                                                    {/* Expired text */}
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: '100%',
                                                        height: '100%'
                                                    }}>
                                                        <div
                                                            className="expired-badge"
                                                            style={{
                                                                background: 'linear-gradient(135deg, rgba(255, 107, 107, 0.8) 0%, rgba(238, 90, 36, 0.8) 50%, rgba(214, 48, 49, 0.8) 100%)',
                                                                color: 'white',
                                                                padding: '15px 25px',
                                                                borderRadius: '15px',
                                                                fontWeight: '800',
                                                                fontSize: '12px',
                                                                textAlign: 'center',
                                                                textShadow: '2px 2px 4px rgba(0,0,0,0.8), 0 0 8px rgba(255,0,0,0.4)',
                                                                letterSpacing: '2px',
                                                                border: '3px solid rgba(255,255,255,0.7)',
                                                                boxShadow: `
                                                                    0 10px 25px rgba(0,0,0,0.2), 
                                                                    inset 0 1px 0 rgba(255,255,255,0.2),
                                                                    0 0 15px rgba(255,0,0,0.2)
                                                                `,
                                                                textTransform: 'uppercase',
                                                                fontFamily: '"Arial Black", Arial, sans-serif',
                                                                whiteSpace: 'nowrap',
                                                                animation: 'expiredPulse 1.8s ease-in-out infinite, expiredGlow 3s ease-in-out infinite alternate',
                                                                position: 'relative',
                                                                overflow: 'hidden'
                                                            }}
                                                        >
                                                            <span style={{ position: 'relative', zIndex: 2 }}>
                                                                EVENT EXPIRED!
                                                            </span>
                                                            {/* Shine effect */}
                                                            <div style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: '-100%',
                                                                width: '100%',
                                                                height: '100%',
                                                                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
                                                                animation: 'shine 3s infinite',
                                                                zIndex: 1
                                                            }}></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div className='row'>
                                                <div className='col-4 card-event-image' >
                                                    <img src={`data:image/png;base64,${item.image}`} className='rounded-3' />
                                                </div>
                                                <div className='col-8 text-start'>
                                                    <div className='card-event-title text-truncate'>{item.eventName}</div>

                                                    <p className='text-truncate-3line card-event-dec'>
                                                        {item.description}
                                                    </p>
                                                    <div>

                                                        <div className='card-event-attr'><BsFillPersonPlusFill /> 
                                                        <span>    
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 400 }}
                                                                overlay={renderTooltip(item.owner)}
                                                                >  
                                                                <span>{firstOwner(item.owner)}</span>
                                                            </OverlayTrigger>
                                                        </span>
                                                    </div>
                                                        <div className='card-event-attr'><BsFillPeopleFill /> <span>{item.totalRecieved} / {(item.memberGroup !== 3) ? item.totalMember : " All Employee"}</span></div>
                                                    </div>

                                                </div>

                                            </div>
                                            <div className='row border-top mt-3 pt-2'>
                                                <div className='col-6 text-start'>
                                                    <div className='card-event-date line-h-38px'><BsCalendar3 />
                                                    <span>
                                                            <span  className='me-1'>
                                                                {convertToG7(item.startDate)}
                                                            </span>
                                                            -
                                                            <span className='ms-1'>
                                                                {convertToG7(item.endDate)}
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className='col-6'>
                                                    <div className='w-100 action-button'>
                                                        <a onClick={() => navigate(`/event/${item.eventNumber}`)} className='goto-event' target='_blank' title='Go to Event'><BiLinkExternal /></a>
                                                        <a className='duplicate-event' onClick={() => copyUrl(`${window.location.origin}/event/${item.eventNumber}`, `${item.eventNumber}`)} title='Copy Event URL'><BiCopy /></a>
                                                        <a className='edit-event' title='Edit Event' onClick={() => navigate(`/events?id=${item.eventNumber}`)} ><BiCalendarEdit /></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div >)
                                );
                            })()
                            :
                            <>

                            </>
                    }
                    {
                       (defualtEvents.length > 0 && keyword === "") ?
                            defualtEvents.map(
                                (item: any,
                                    index: number) => (
                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 p-3' key={`B${index}`}>
                                        <div className='event-item-card h-100 commingSoon'>
                                            <label>Coming Soon</label>
                                        </div>
                                    </div >)
                            )
                            :
                            <>

                            </>
                    }
                </div>
                {/* <div className='page-info'>
                    Showing {eventsLists.eventsLists.length ?? 0} of {eventsLists.total} Events
                </div> */}
                
                <div className='my-3 mx-auto'>
                    {
                        (() => {
                            const filteredEventsCount = eventsLists.eventsLists.filter((item: any) => {
                                if (expiredFilter === 'all') return true;
                                const expired = isEventExpired(item.startDate, item.endDate);
                                if (expiredFilter === 'active') return !expired;
                                if (expiredFilter === 'expired') return expired;
                                return true;
                            }).length;
                            
                            const filteredTotalPages = Math.ceil(filteredEventsCount / limit);
                            
                            return filteredTotalPages > 1 ? (
                            <>
                          
                                <ReactPaginate
                                    previousLabel="Previous"
                                    nextLabel="Next"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakLabel="..."
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    pageCount={filteredTotalPages}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName="pagination"
                                    activeClassName="active"
                                    forcePage={Math.floor(offset / limit)}
                                />
                            </>
                            ) : null;
                        })()
                    }

                </div>
            </div>

            <ConfirmModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                onDelete={() => hendleDelete()}
            />
            <ToastContainer />
        </>
    )
}

export default MyEvent
